import { asReadonlyBS } from '@ocodelib/ex-util/rx';
import initSwc, { transformSync } from '@swc/wasm-web';
import { BehaviorSubject } from 'rxjs';

export function makeP5DrawHook() {
  const ctx = { canceled: false };
  const scriptUrl$ = new BehaviorSubject<string | null>(null);

  // initSwc
  (async () => {
    await initSwc();
    if (ctx.canceled) return;
    const sourceCode = transformSync(DRAW_HOOK_SOURCE, {
      filename: '__p5_draw_hook.js',
    }).code;

    const blob = new Blob([sourceCode], { type: 'application/javascript' });
    scriptUrl$.next(URL.createObjectURL(blob));
  })();

  function destroy() {
    ctx.canceled = true;
    const scriptUrl = scriptUrl$.value;
    if (scriptUrl) {
      URL.revokeObjectURL(scriptUrl);
      scriptUrl$.next(null);
    }
  }

  return {
    drawHookScriptUrl$: asReadonlyBS(scriptUrl$),
    destroy,
  };
}

const DRAW_HOOK_SOURCE = `
(function () {
  const __orginalDraw__ = typeof window.draw == 'function' ? window.draw : undefined;
  if ( !window.parent ) return;
  if ( __orginalDraw__ ) {
    window.draw = function() {
      __orginalDraw__();
      window.parent.postMessage({ type: "p5_postdraw" });
    };
  } else {
    window.draw = function() {
      window.parent.postMessage({ type: "p5_postdraw" });
    };
  }

  window.addEventListener('message', function(evt) {
      if(typeof evt.data === 'object' && evt.data.type === 'p5_snapshot') {
        window.parent.postMessage({type: 'p5_snapshot_result', value: canvas.toDataURL()});
      }
  });
})();
`;
